// src/pages/ReturnItemsList.jsx (ya iske jaisa koi naam)
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FaEye,
    FaEdit,
    FaAngleLeft,
    FaAngleRight,
} from 'react-icons/fa'; // Importing necessary icons

export default function PurchaseOrder() {
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480);
    const [containerDynamicHeight, setContainerDynamicHeight] = useState('auto');

    // Sample data for return items
    const [returns, setReturns] = useState([
        { id: '13445', customer: 'Haider zakir', item: 'Perfume', returnDate: '26 April 2025', total: 5000 },
        { id: '13446', customer: 'Ali Khan', item: 'Book', returnDate: '25 April 2025', total: 1500 },
        { id: '13447', customer: 'Usman Raza', item: 'Headphones', returnDate: '24 April 2025', total: 3000 },
        { id: '13448', customer: 'Fatima Bibi', item: 'Dress', returnDate: '23 April 2025', total: 7000 },
        { id: '13449', customer: 'Aisha Malik', item: 'Toy Car', returnDate: '22 April 2025', total: 800 },
        { id: '13450', customer: 'Ahmed Sohail', item: 'Laptop Bag', returnDate: '21 April 2025', total: 2500 },
        { id: '13451', customer: 'Sana Javed', item: 'Coffee Mug', returnDate: '20 April 2025', total: 500 },
        { id: '13452', customer: 'Imran Abbas', item: 'Watch', returnDate: '19 April 2025', total: 4500 },
        { id: '13453', customer: 'Zara Noor', item: 'Keyboard', returnDate: '18 April 2025', total: 3200 },
    ]);

    useEffect(() => {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            const currentHeight = window.innerHeight;

            setIsMobile(currentWidth <= 768);
            setIsSmallMobile(currentWidth <= 480);

            // Calculate height for the container, similar to previous components
            const calculatedHeight = currentHeight - (isMobile ? 40 : 80);
            setContainerDynamicHeight(Math.max(calculatedHeight, 600)); // Ensure min height
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Call once initially to set the correct size
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isMobile]);

    const handleViewReturn = (id) => {
        console.log('Viewing Return ID:', id);
        // navigate(`/return-details/${id}`); // Example navigation
    };

    const handleEditReturn = (id) => {
        console.log('Edit Return:', id);
    };

    const handleAddReturnItem = () => {
        console.log('Add New Return Item');
        // navigate('/add-return-item'); // Example navigation
    };

    const styles = {
        mainWrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            width: '100%',
            backgroundColor: 'transparent', // Consistent background
            padding: isSmallMobile ? '0px' : (isMobile ? '15px' : '20px'),
            boxSizing: 'border-box',
            fontFamily: 'Inter, sans-serif',
            overflow: 'hidden',
        },
        returnItemsListPageContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '1200px',
            height: containerDynamicHeight,
            backgroundColor: '#E5D0A5', // Main container background
            borderRadius: '10px',
            overflowY: 'auto',
            padding: isSmallMobile ? '15px' : '20px',
            boxSizing: 'border-box',
        },
        headerTitle: {
            fontSize: isSmallMobile ? '20px' : (isMobile ? '24px' : '30px'),
            color: '#000', // Dark text for titles
            marginBottom: isSmallMobile ? '15px' : '20px',
            fontWeight: 'bold',
            textAlign: 'left',
        },
        returnListContainer: {
            backgroundColor: '#000', // Black background for the table section
            borderRadius: '10px',
            padding: isSmallMobile ? '15px' : '20px',
            color: '#E5D0A5', // Light text for this section
            flexGrow: 1, // Allow it to take available space
            display: 'flex',
            flexDirection: 'column',
        },
        returnListHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
            flexDirection: isSmallMobile ? 'column' : 'row',
            gap: isSmallMobile ? '10px' : '0',
            textAlign: isSmallMobile ? 'center' : 'left',
        },
        returnListTitle: {
            fontSize: isSmallMobile ? '16px' : '20px',
            margin: 0,
            fontWeight: 'bold',
        },
        addButton: {
            backgroundColor: '#E5D0A5', // Light background for Add button
            color: '#000', // Dark text for Add button
            border: 'none',
            borderRadius: '5px',
            padding: '8px 15px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            transition: 'background-color 0.2s ease',
            whiteSpace: 'nowrap', // Prevent text wrap on small screens
        },
        addButtonHover: {
            backgroundColor: '#d0b98e', // Slightly darker hover for Add button
        },
        tableWrapper: {
            overflowX: 'auto',
            marginBottom: '15px',
            flexGrow: 1, // Allows table to expand and scroll if needed
            '::-webkit-scrollbar': {
                display: 'none'
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            minWidth: isMobile ? '600px' : '750px', // Adjusted min-width for fewer columns
        },
        tableHeader: {
            backgroundColor: '#000', // Table header background (same as container)
            color: '#E5D0A5', // Light text for header
            fontSize: '12px',
            textAlign: 'left',
            padding: '8px 0',
            borderBottom: '1px solid #333', // Subtle border
        },
        th: {
            // Increased padding for header cells (consistent with ReceivedOrderList)
            padding: '16px 10px',
            whiteSpace: 'nowrap',
        },
        tableRow: {
            borderBottom: '1px solid #333', // Subtle border between rows
        },
        tableRowHover: {
            backgroundColor: '#1a1a1a', // Darker on hover
        },
        td: {
            // Increased padding for table data cells (consistent with ReceivedOrderList)
            padding: '16px 10px',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            fontSize: '12px',
        },
        actionButtons: {
            display: 'flex',
            gap: '4px',
            justifyContent: 'center',
        },
        actionButton: {
            backgroundColor: '#E5D0A5', // Light background for action buttons
            border: 'none',
            borderRadius: '5px',
            padding: '5px 7px',
            cursor: 'pointer',
            fontSize: '12px',
            color: '#000', // Dark text/icon for action buttons
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s ease',
        },
        actionButtonHover: {
            backgroundColor: '#d0b98e', // Slightly darker hover
        },
        actionButtonIcon: {
            fontSize: '13px',
        },
        paginationContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '15px',
            flexDirection: isSmallMobile ? 'column' : 'row',
            gap: isSmallMobile ? '10px' : '0',
            padding: '0 5px',
        },
        paginationControls: {
            display: 'flex',
            gap: '4px',
            flexWrap: 'wrap',
            justifyContent: isSmallMobile ? 'center' : 'flex-start',
        },
        paginationButton: {
            backgroundColor: '#E5D0A5', // Light background for pagination buttons
            color: '#000', // Dark text for pagination buttons
            border: '1px solid #000', // Dark border
            borderRadius: '5px',
            padding: '4px 8px',
            cursor: 'pointer',
            fontSize: '12px',
            transition: 'background-color 0.2s ease',
            minWidth: '25px',
            textAlign: 'center',
        },
        paginationButtonActive: {
            backgroundColor: '#000', // Black background for active pagination button
            color: '#E5D0A5', // Light text for active pagination button
        },
        paginationButtonHover: {
            backgroundColor: '#d0b98e', // Hover for pagination buttons
        },
        paginationText: {
            color: '#E5D0A5', // Light text for pagination result count
            fontSize: '12px',
            marginTop: isSmallMobile ? '8px' : '0',
        },
    };

    // Pagination logic (simplified, assuming all returns shown for now)
    const totalResults = returns.length; // You would replace this with actual total count from API

    return (
        <div style={styles.mainWrapper}>
            <div style={styles.returnItemsListPageContainer}>
                <h1 style={styles.headerTitle}>Return Items</h1>

                {/* All Return List Section */}
                <div style={styles.returnListContainer}>
                    <div style={styles.returnListHeader}>
                        <h2 style={styles.returnListTitle}>All Return List</h2>
                        <button
                            style={styles.addButton}
                            onClick={handleAddReturnItem}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.addButtonHover.backgroundColor}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.addButton.backgroundColor}
                        >
                            Add Return Item
                        </button>
                    </div>

                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead style={styles.tableHeader}>
                                <tr>
                                    <th style={styles.th}>ID</th>
                                    <th style={styles.th}>Customer</th>
                                    <th style={styles.th}>Item</th>
                                    <th style={styles.th}>Return Date</th>
                                    <th style={styles.th}>Total</th>
                                    <th style={styles.th}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {returns.map((item, index) => (
                                    <tr
                                        key={item.id}
                                        style={styles.tableRow}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.tableRowHover.backgroundColor}
                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                    >
                                        <td style={styles.td}>#{item.id}</td>
                                        <td style={styles.td}>{item.customer}</td>
                                        <td style={styles.td}>{item.item}</td>
                                        <td style={styles.td}>{item.returnDate}</td>
                                        <td style={styles.td}>{item.total}</td>
                                        <td style={styles.td}>
                                            <div style={styles.actionButtons}>
                                                <button
                                                    style={styles.actionButton}
                                                    onClick={() => handleViewReturn(item.id)}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.actionButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.actionButton.backgroundColor}
                                                >
                                                    <FaEye style={styles.actionButtonIcon} />
                                                </button>
                                                <button
                                                    style={styles.actionButton}
                                                    onClick={() => handleEditReturn(item.id)}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.actionButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.actionButton.backgroundColor}
                                                >
                                                    <FaEdit style={styles.actionButtonIcon} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination - Consistent with previous components */}
                    <div style={styles.paginationContainer}>
                        <div style={styles.paginationControls}>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                <FaAngleLeft />
                            </button>
                            <button
                                style={{ ...styles.paginationButton, ...styles.paginationButtonActive }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonActive.backgroundColor}
                            >
                                1
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                2
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                3
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                4
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                5
                            </button>
                            <span style={styles.paginationText}> ...... </span>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                10
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                <FaAngleRight />
                            </button>
                        </div>
                        <p style={styles.paginationText}>{totalResults} Results</p>
                    </div>
                </div>
            </div>
        </div>
    );
}